/* Verdino · comportamenti del restyling. Nessuna libreria. Ogni parte è isolata: se una fallisce, le altre funzionano. */
(function () {
  'use strict';

  var ridotto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function prova(nome, fn) { try { fn(); } catch (e) { if (window.console) console.warn('[verdino] ' + nome + ':', e); } }

  /* ---------- menu del telefono: <dialog> nativo ---------- */
  prova('menu', function () {
    var dialogo = document.getElementById('VMenuMobile');
    var apri = document.querySelector('[data-v-apri-menu]');
    if (!dialogo || !apri || typeof dialogo.showModal !== 'function') return;
    apri.addEventListener('click', function () {
      dialogo.showModal();
      apri.setAttribute('aria-expanded', 'true');
    });
    dialogo.addEventListener('close', function () {
      apri.setAttribute('aria-expanded', 'false');
      apri.focus();
    });
    dialogo.addEventListener('click', function (e) {
      if (e.target === dialogo) dialogo.close();                 // clic sullo sfondo
      if (e.target.closest('[data-v-chiudi-menu]')) dialogo.close();
    });
  });

  /* ---------- icona della ricerca: riapre la riga di ricerca sul telefono ---------- */
  prova('cerca', function () {
    var header = document.querySelector('[data-v-header]');
    var bottone = document.querySelector('[data-v-apri-cerca]');
    if (!header || !bottone) return;
    bottone.addEventListener('click', function () {
      var aperta = header.classList.toggle('v-header--cerca-aperta');
      bottone.setAttribute('aria-expanded', aperta ? 'true' : 'false');
      if (aperta) { var campo = header.querySelector('.v-cerca input[type=search]'); if (campo) campo.focus(); }
    });
  });

  /* ---------- header compatto sul telefono mentre si scorre in giù ----------
     Quando l'header cambia altezza (la riga di ricerca rientra o torna), il browser sposta lo scorrimento della stessa misura per
     tenere ferma la pagina (scroll anchoring: Chrome, Android). Letto come un movimento dell'utente, quello spostamento faceva
     rimbalzare l'header fra le due altezze a ogni fotogramma, sulla soglia e a ogni cambio di verso (misurato il 16/10: 20 cambi
     a meno di 120 ms in uno scorrimento, salti di 48 px). Quindi il riferimento si sposta della differenza di altezza, e la soglia
     per compattare si alza di quanto l'header si accorcia, così la correzione del browser non la riattraversa. */
  prova('header', function () {
    var header = document.querySelector('[data-v-header]');
    if (!header) return;
    var ultimo = window.scrollY, attesa = false, salto = 60;   // di quanto si accorcia l'header compatto: misurato al primo cambio
    function cambia(compatto, y) {
      var prima = header.offsetHeight;
      header.classList.toggle('v-header--compatto', compatto);
      var differenza = prima - header.offsetHeight;            // positiva quando si accorcia
      if (compatto && differenza > 0) salto = differenza;
      ultimo = y - differenza;                                 // dove il browser sta per portare lo scorrimento
    }
    function aggiorna() {
      attesa = false;
      var y = window.scrollY;
      var campo = header.querySelector('.v-cerca input');
      if (campo && document.activeElement === campo) { ultimo = y; return; }   // mai chiudere la ricerca mentre si scrive
      var compatto = header.classList.contains('v-header--compatto');
      if (!compatto && y > 160 + salto && y > ultimo + 4) cambia(true, y);
      else if (compatto && (y < ultimo - 4 || y < 160)) cambia(false, y);
      else ultimo = y;
    }
    window.addEventListener('scroll', function () { if (!attesa) { attesa = true; requestAnimationFrame(aggiorna); } }, { passive: true });
  });

  /* ---------- data stimata di consegna, con l'ora di Roma ----------
     Formati: 'scheda' e 'carrello' (riga in evidenza), 'hero' (esempio nell'apertura della home), altro (frase lunga).
     Il cassetto del carrello viene ridisegnato dopo ogni aggiunta: un osservatore compila le righe nuove. */
  var mesi = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
  var giorni = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];
  function iso(d) { return d.toISOString().slice(0, 10); }
  function compilaConsegna(nodo) {
    if (!window.Intl || nodo.hasAttribute('data-v-fatto')) return;
    // ora e data di Roma, qualunque sia il fuso di chi guarda
    var parti = {};
    new Intl.DateTimeFormat('it-IT', { timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
      .formatToParts(new Date()).forEach(function (p) { parti[p.type] = p.value; });
    var oggi = new Date(Date.UTC(+parti.year, +parti.month - 1, +parti.day));
    var minuti = (+parti.hour % 24) * 60 + (+parti.minute);
    var festivi = (nodo.getAttribute('data-festivi') || '').split(',').filter(Boolean);
    var lavorativo = function (d) { var g = d.getUTCDay(); return g !== 0 && g !== 6 && festivi.indexOf(iso(d)) === -1; };
    var piu = function (d, n) { var x = new Date(d.getTime()); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (lavorativo(x)) n--; } return x; };
    var oraLimite = (nodo.getAttribute('data-ora') || '12:30').split(':');
    var limite = (+oraLimite[0]) * 60 + (+(oraLimite[1] || 0));
    var min = parseInt(nodo.getAttribute('data-min'), 10) || 3;
    var max = parseInt(nodo.getAttribute('data-max'), 10) || 7;
    // parte oggi se è lavorativo e prima dell'ora limite, altrimenti il prossimo giorno lavorativo
    var oggiParte = lavorativo(oggi) && minuti < limite;
    var partenza = oggiParte ? oggi : piu(oggi, 1);
    var da = piu(partenza, min), a = piu(partenza, max);
    var testoData = function (d) { return giorni[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + mesi[d.getUTCMonth()]; };
    // stesso mese: «fra lunedì 19 e venerdì 23 ottobre»
    var primo = da.getUTCMonth() === a.getUTCMonth() ? giorni[da.getUTCDay()] + ' ' + da.getUTCDate() : testoData(da);
    var intervallo = 'fra ' + primo + ' e ' + testoData(a);
    var formato = nodo.getAttribute('data-formato');
    var testo;
    if (formato === 'scheda' || formato === 'carrello') {
      testo = 'Arriva ' + intervallo + (oggiParte ? ', se ordini entro le ' + oraLimite.join(':') : '');
    } else if (formato === 'hero') {
      testo = 'Ordini oggi? Arriva ' + intervallo + '.';
    } else {
      testo = (oggiParte ? 'Se ordini entro le ' + oraLimite.join(':') + ', parte oggi' : 'Se ordini ora, parte il prossimo giorno lavorativo') + ' e arriva ' + intervallo + '.';
    }
    var dove = nodo.querySelector('[data-v-consegna-testo]') || nodo;
    dove.textContent = testo;
    nodo.setAttribute('data-v-fatto', '');
    nodo.hidden = false;
  }
  prova('consegna', function () {
    var tutte = function () { document.querySelectorAll('[data-v-consegna]:not([data-v-fatto])').forEach(function (n) { prova('consegna-riga', function () { compilaConsegna(n); }); }); };
    tutte();
    if (window.MutationObserver) {
      var attesa = false;
      new MutationObserver(function () { if (!attesa) { attesa = true; requestAnimationFrame(function () { attesa = false; tutte(); }); } })
        .observe(document.body, { childList: true, subtree: true });
    }
  });

  /* ---------- pillole delle sottocategorie: «Mostra tutte» ---------- */
  prova('pillole', function () {
    document.querySelectorAll('[data-v-pillole]').forEach(function (b) {
      var elenco = document.getElementById(b.getAttribute('data-v-pillole'));
      if (!elenco) return;
      var testo = b.textContent;
      b.addEventListener('click', function () {
        var aperte = elenco.classList.toggle('is-aperte');
        b.setAttribute('aria-expanded', aperte ? 'true' : 'false');
        b.textContent = aperte ? 'Mostra meno' : testo;
      });
    });
  });

  /* ---------- barra d'acquisto fissa ---------- */
  prova('barra', function () {
    var barra = document.querySelector('[data-v-barra-acquisto]');
    if (!barra) return;
    var riferimento = document.querySelector(barra.getAttribute('data-riferimento'));
    if (!riferimento) return;
    // controllo deterministico sulla posizione, un rAF per scorrimento (IntersectionObserver salta gli elementi con lo scorrimento veloce)
    var attesa = false;
    function aggiorna() {
      attesa = false;
      var r = riferimento.getBoundingClientRect();
      var visibile = r.bottom < 0;                        // il pulsante vero è salito sopra lo schermo
      barra.classList.toggle('is-visibile', visibile);
      // altezza vera della barra (cambia con il margine di sicurezza dell'iPhone): serve ad alzare il pulsante WhatsApp flottante
      document.documentElement.style.setProperty('--v-barra-alta', barra.offsetHeight + 'px');
      barra.setAttribute('aria-hidden', visibile ? 'false' : 'true');
      barra.inert = !visibile;
    }
    window.addEventListener('scroll', function () { if (!attesa) { attesa = true; requestAnimationFrame(aggiorna); } }, { passive: true });
    window.addEventListener('resize', aggiorna);
    aggiorna();
    var bottone = barra.querySelector('[data-v-aggiungi]');
    if (bottone) bottone.addEventListener('click', function () {
      var vero = document.querySelector(barra.getAttribute('data-pulsante'));
      if (vero && !vero.disabled) { vero.click(); }
      else { riferimento.scrollIntoView({ behavior: ridotto ? 'auto' : 'smooth', block: 'center' }); }
    });
    // il prezzo della barra segue la variante scelta
    document.addEventListener('change', function () {
      setTimeout(function () {
        var prezzo = document.querySelector(barra.getAttribute('data-prezzo'));
        var dove = barra.querySelector('[data-v-barra-prezzo]');
        if (prezzo && dove) { var p = prezzo.querySelector('.price-item--sale, .price-item--regular'); if (p) dove.textContent = p.textContent.trim(); }
      }, 400);
    });
  });

  /* ---------- confezione regalo e biglietto, come attributi dell'ordine ---------- */
  function aggiornaAttributi(attributi) {
    return fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributi })
    });
  }
  // l'esito si scrive accanto alla casella: un salvataggio fallito non deve sembrare riuscito
  function esitoRegalo(blocco, testo, errore) {
    var p = blocco && blocco.querySelector('[data-v-regalo-esito]');
    if (!p) return;
    p.textContent = testo;
    p.classList.toggle('is-errore', !!errore);
  }
  prova('regalo', function () {
    var timer = null;
    document.addEventListener('change', function (e) {
      var casella = e.target.closest && e.target.closest('[data-v-regalo]');
      if (!casella) return;
      var blocco = casella.closest('.v-regalo');
      var area = blocco && blocco.querySelector('[data-v-biglietto]');
      if (area) area.closest('.v-regalo__biglietto').hidden = !casella.checked;
      esitoRegalo(blocco, 'Salvataggio…');
      aggiornaAttributi({ 'Confezione regalo': casella.checked ? 'Sì' : '', 'Biglietto': casella.checked && area ? area.value : '' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          esitoRegalo(blocco, casella.checked ? 'Confezione regalo aggiunta all\'ordine.' : 'Confezione regalo tolta.');
        })
        .catch(function () {
          casella.checked = !casella.checked;
          if (area) area.closest('.v-regalo__biglietto').hidden = !casella.checked;
          esitoRegalo(blocco, 'Non siamo riusciti a salvare la scelta. Riprova, oppure scrivilo nelle note al pagamento.', true);
        });
    });
    document.addEventListener('input', function (e) {
      var area = e.target.closest && e.target.closest('[data-v-biglietto]');
      if (!area) return;
      clearTimeout(timer);
      var blocco = area.closest('.v-regalo');
      timer = setTimeout(function () {
        aggiornaAttributi({ 'Biglietto': area.value })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); esitoRegalo(blocco, 'Messaggio salvato.'); })
          .catch(function () { esitoRegalo(blocco, 'Il messaggio non è stato salvato. Riprova tra poco.', true); });
      }, 700);
    });
  });

  /* ---------- newsletter: iscrizione diretta alla lista di Klaviyo ----------
     Con chiave pubblica e lista nelle impostazioni del tema, la fascia della newsletter iscrive con l'API pubblica di Klaviyo
     (client/subscriptions): così partono la doppia conferma e poi il benvenuto, qualunque sia la sincronizzazione fra Shopify
     e Klaviyo. Se Klaviyo non risponde o rifiuta (rete, blocco della pubblicità, errore), il modulo parte com'era, verso Shopify,
     che crea il cliente iscritto al marketing e risponde coi suoi messaggi: l'iscrizione non si perde e il sito non inventa un
     esito. Senza JavaScript il modulo è quello di Shopify.
     L'ascolto è in CATTURA: l'antispam di Shopify (hCaptcha) ascolta l'invio sul documento e, una volta legato il modulo (al primo
     clic nel campo), lo spedisce subito a Shopify con form.submit(). Quando l'iscrizione la fa Klaviyo l'evento si ferma qui;
     quando si ripiega su Shopify il modulo si rimanda con requestSubmit() e passa da tutti, antispam compreso. */
  prova('newsletter', function () {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      var dati = form && form.closest && form.closest('[data-v-klaviyo-lista]');
      if (!dati || form.tagName !== 'FORM' || form.getAttribute('data-v-verso') === 'shopify') return;
      var azienda = dati.getAttribute('data-v-klaviyo-azienda');
      var lista = dati.getAttribute('data-v-klaviyo-lista');
      var campo = form.querySelector('input[type="email"]');
      if (!azienda || !lista || !campo || !window.fetch) return;            // niente Klaviyo: parte il modulo di Shopify
      e.preventDefault();
      e.stopImmediatePropagation();                                         // l'antispam di Shopify non deve spedirlo in parallelo
      if (form.getAttribute('aria-busy') === 'true') return;               // secondo clic mentre il primo è in corso
      form.setAttribute('aria-busy', 'true');
      var pulsante = form.querySelector('[type="submit"]');
      if (pulsante) pulsante.disabled = true;
      var libera = function () { form.removeAttribute('aria-busy'); if (pulsante) pulsante.disabled = false; };
      var aShopify = function () {
        libera();
        form.setAttribute('data-v-verso', 'shopify');
        if (form.requestSubmit) form.requestSubmit(); else HTMLFormElement.prototype.submit.call(form);
      };
      var corpo = { data: { type: 'subscription', attributes: {
        custom_source: dati.getAttribute('data-v-fonte') || 'Sito',
        profile: { data: { type: 'profile', attributes: { email: campo.value.trim(), subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
      }, relationships: { list: { data: { type: 'list', id: lista } } } } };
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(azienda), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2026-10-15' },
        body: JSON.stringify(corpo)
      }).then(function (r) {
        if (!r.ok) { aShopify(); return; }
        libera();
        campo.value = '';
        var esito = form.querySelector('[data-v-esito]');
        if (!esito) return;
        esito.querySelector('[data-v-esito-testo]').textContent = dati.getAttribute('data-v-testo-esito') || 'Iscrizione ricevuta.';
        var icona = esito.querySelector('.svg-wrapper');
        if (icona) icona.hidden = false;
        esito.classList.add('is-pieno');
      }, aShopify);   // il ripiego solo se la richiesta fallisce: un errore nel mostrare l'esito non deve iscrivere una seconda volta
    }, true);
  });
})();
